import { ButtonColors } from '~/components/ui/Button';
import { WalletType } from '~/shared';
import { ISelectDiscountItem } from '../SelectDiscount';

export enum VariationMode {
	Variant = 'variant',
	Count = 'count',
}

export interface IShopPreviewProps {
	name: string;
	price: number;
	handlePayByCash?: () => void;
	handlePayByCard?: () => void;
	handlePayByDonate?: () => void;
	visible: boolean;
	subtitle?: string;
	description?: string;
	walletType?: WalletType;
	variationTitle?: string;
	variationMode?: VariationMode;
	variationIndex?: number;
	onVariationChange?: (newIndex: number) => void;
	maxVariantIndex?: number;
	discount?: number;
	oldPrice?: number;
	customButtons?: {
		color: ButtonColors;
		text: string;
		icon?: string;
		disabled?: boolean;
		onClick: () => void;
	}[];
	bottomTitle?: string;
	selectDiscount?: {
		items: (ISelectDiscountItem | null)[];
		value: ISelectDiscountItem | null;
		onChange: (value: ISelectDiscountItem | null) => void;
	};
	hide?: {
		buttons?: boolean;
		price?: boolean;
	};
	stock?: number;
}
